const labels = {
    en: {
        whatsAppLabel: "ASK US\nNOW"
    },
    ms: {}
};

export default labels;
